import { createContext, FC, ReactElement, useContext, useState } from 'react'

const CurrentLocationContext = createContext<{
  propertyId: number | null
  setPropertyId: any
}>({
  propertyId: null,
  setPropertyId: null,
})

export const useCurrentLocation = () => useContext(CurrentLocationContext)

export const CurrentLocationProvider: FC<{ children: ReactElement }> = ({
  children,
}) => {
  const [propertyId, setPropertyId] = useState(null)

  return (
    <CurrentLocationContext.Provider
      value={{
        propertyId,
        setPropertyId,
      }}
    >
      {children}
    </CurrentLocationContext.Provider>
  )
}
